import { render, staticRenderFns } from "./EnvelopeStatusBadge.vue?vue&type=template&id=bdf4f814"
import script from "./EnvelopeStatusBadge.vue?vue&type=script&lang=js"
export * from "./EnvelopeStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports